import { defineStore } from "pinia";
import { addDays, subDays, formatISO } from "date-fns";
import { getTimezoneOffset, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export const useDateStore = defineStore("dateStore", {
  state: () => ({
    selectedDate: new Date(),
    duration: 0,
    firstDay: "",
  }),
  actions: {
    setDate(date) {
      this.selectedDate = date;
    },
    addOneDay() {
      this.selectedDate = addDays(this.selectedDate, 1);
    },
    subtractOneDay() {
      this.selectedDate = subDays(this.selectedDate, 1);
    },
    today() {
      this.selectedDate = new Date();
    },
  },
  getters: {
    getISODate(state) {
      // return formatISO(utcToZonedTime(state.selectedDate, "UTC"), {
      //   representation: "date",
      // });
      return state.selectedDate.toISOString().split("T").shift();
    },
  },
});
